import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NzFormModule } from 'ng-zorro-antd/form';
import { NzCascaderModule } from 'ng-zorro-antd/cascader';
import {
  SelectEngineerSpecializationFormComponent
} from './components/engineer-specialization/select-engineer-specialization-form.component';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { ProcessHistoryComponent } from './components/process-history/process-history.component';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { ShowProcessHistoryButtonComponent } from './components/process-history/show-process-history-button.component';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { IconsProviderModule } from '../icons-provider.module';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { RegionViewComponent } from './components/region-view/region-view.component';
import { ProjectTypeViewComponent } from './components/project-type-view/project-type-view.component';
import { StatusViewComponent } from './components/status-view/status-view.component';
import { FileUploadComponent } from './components/files/file-upload.component';
import { FileDownloadLinkComponent } from './components/files/file-download-link.component';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { CommentModalComponent } from './components/comment-modal/comment-modal.component';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzCommentModule } from 'ng-zorro-antd/comment';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzListModule } from 'ng-zorro-antd/list';
import { NgPipesModule } from 'ngx-pipes';
import { AppPipesModule } from '../_pipes/app-pipes';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { DateCellComponent } from '@app/_shared/components/date-cell/date-cell.component';
import { NzSelectModule } from 'ng-zorro-antd/select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzFormModule,
    NzInputModule,
    NzInputNumberModule,
    NzDatePickerModule,
    NzSelectModule,
    NzCascaderModule,
    NzTagModule,
    NzDividerModule,
    NzTimelineModule,
    NzDrawerModule,
    NzButtonModule,
    IconsProviderModule,
    NzToolTipModule,
    NzUploadModule,
    NzModalModule,
    NzCommentModule,
    NzAvatarModule,
    NzListModule,
    NgPipesModule,
    AppPipesModule,
    FileUploadComponent,
    StatusViewComponent,
    FileDownloadLinkComponent,
    RegionViewComponent,
    ProjectTypeViewComponent,
    ShowProcessHistoryButtonComponent,
    CommentModalComponent,
    DateCellComponent,
    SelectEngineerSpecializationFormComponent,
    ProcessHistoryComponent,
  ],
  exports: [
    SelectEngineerSpecializationFormComponent,
    ProcessHistoryComponent,
    ShowProcessHistoryButtonComponent,
    RegionViewComponent,
    ProjectTypeViewComponent,
    StatusViewComponent,
    FileUploadComponent,
    FileDownloadLinkComponent,
    CommentModalComponent,
    DateCellComponent,
  ],
})
export class SharedModule {}
